import { DELETED_USER_SENTINEL } from '@splitfiesta/shared';

/** Resolves an API-enriched user name for display: sentinel → localized
 *  "Deleted user", missing → localized "Unknown". Pass the t() from
 *  useTranslation (keys are fully qualified). */
export function resolveUserName(
  name: string | null | undefined,
  t: (key: string) => string
): string {
  if (!name) return t('common:labels.unknown');
  if (name === DELETED_USER_SENTINEL) return t('common:labels.deletedUser');
  return name;
}
